module.exports = __webpack_public_path__ + "static/media/jisung-1.jpeg";